import i18n from ".";
import { normalizeMonitoringTaskType } from "../utils/tasks/normalizeMonitoringTaskType";

const taskTranslationKeys: Record<string, string> = {
  "Atualizar lote": "updateBatch",
  "Dividir lote": "splitBatch",
  "Evoluir categoria": "evolveCategory",
  "Movimentar lote": "moveBatch",
  "Junção de lotes": "mergeBatches",
  "Atualizar rota de pastejo": "updateGrazingRoute",
  "Transferência de Lote": "transferBatch",
  "Coleta de pluviometria": "rainfallCollection",
  Adubação: "fertilization",
  Bebedouro: "waterTrough",
  Cerca: "fence",
  "Tarefa avulsa": "detached",
  "Curva de nível": "contour",
  Plantio: "planting",
  "Preparo de solo": "soilPreparation",
  Pulverização: "spraying",
  "Recebimento do produto": "productIncoming",
  "Saída do produto": "productDispatch",
  Roçagem: "brushCutting",
  "Coleta de Informações": "collectInformation",
  MICRO_AREA_MONITOR: "collectInformation",
  "Movimentação de Faixa": "stripMovement",
  STRIP_MOVEMENT: "stripMovement",
  FERTILIZATION: "fertilization",
  DETACHED_TASK: "detached",
  WATER_TROUGH: "waterTrough",
  Bebedouros: "waterTrough",
  FENCING: "fence",
  Cercas: "fence",
  CONTOUR_FARMING: "contour",
  PLANTING: "planting",
  SOIL_PREPARATION: "soilPreparation",
  SPRAYING: "spraying",
  PRODUCT_INCOMING: "productIncoming",
  PRODUCT_DISPATCH: "productDispatch",
  BRUSH_CUTTING: "brushCutting",
  Nascimento: "birth",
  Compra: "purchase",
  Venda: "sale",
  Abate: "slaughter",
  Morte: "death",
  "Ajuste de Inventário Entrada Forçado": "forcedInventoryEntry",
  "Ajuste de Inventário Saída Forçado": "forcedInventoryExit",
  "Ajuste de Inventário Entrada": "inventoryEntry",
  "Ajuste de Inventário Saída": "inventoryExit",
  "Ajuste de Inventário em Lote": "batchInventoryAdjustment",
};

const normalizedTaskTranslationKeys: Record<string, string> = {
  NASCIMENTO: "birth",
  NASCIMENTO_DE_ANIMAIS: "birth",
  ANIMAL_BIRTH: "birth",
  BIRTH: "birth",
  COMPRA: "purchase",
  COMPRA_DE_ANIMAIS: "purchase",
  ANIMAL_PURCHASE: "purchase",
  PURCHASE: "purchase",
  VENDA: "sale",
  VENDA_DE_ANIMAIS: "sale",
  ANIMAL_SALE: "sale",
  SALE: "sale",
  MORTE: "death",
  MORTE_DE_ANIMAIS: "death",
  ANIMAL_DEATH: "death",
  DEATH: "death",
};

function normalizeTask(task: string) {
  return task
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .replace(/[ -]+/g, "_")
    .toUpperCase();
}

const statusTranslationKeys: Record<string, string> = {
  COMPLETED: "completed",
  "CONCLUÍDO": "completed",
  CONCLUIDO: "completed",
  PENDING: "pending",
  PENDENTE: "pending",
  ACCEPTED: "accepted",
  ACEITO: "accepted",
  ACEITA: "accepted",
  CANCELED: "canceled",
  CANCELLED: "canceled",
  CANCELADO: "canceled",
  CANCELADA: "canceled",
  ERROR: "error",
  ERRO: "error",
};

export const translateMonitoringTask = (task?: string): string => {
  if (!task) return "";

  const translationKey = taskTranslationKeys[normalizeMonitoringTaskType(task)] || normalizedTaskTranslationKeys[normalizeTask(task)];
  return translationKey
    ? i18n.t(`taskMonitoring.tasks.${translationKey}`)
    : task;
};

export const translateMonitoringStatus = (status?: string): string => {
  if (!status) return "";

  const translationKey = statusTranslationKeys[status.trim().toLocaleUpperCase("pt-BR")];
  return translationKey
    ? i18n.t(`taskMonitoring.statuses.${translationKey}`)
    : status;
};

export const isCompletedMonitoringStatus = (status?: string): boolean =>
  statusTranslationKeys[status?.trim().toLocaleUpperCase("pt-BR") || ""] === "completed";
